'use client'

import Footer from '@/components/layout/Footer'
import Header from '@/components/layout/Header'
import Main from '@/components/layout/Main'
import { useScrollTracking } from '@/hooks/useScrollTracking'

const Home = () => {
  useScrollTracking()

  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <Main />
      <Footer />
    </div>
  )
}

export default Home
